.searchInput {
  background-color: rgba(0, 0, 0, 0.2);
  border: none;
  color: var(--mantine-color-white);
}

.searchInput::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.searchSection {
  color: rgba(255, 255, 255, 0.6);
}

.dimmed {
  color: rgba(255, 255, 255, 0.6);
}

.pendingPill {
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 9999px;
}
